export const getTranslatedColumnListByKeyAsOptions = (key) => (state) => {
  const translatedColumnList = state.translatedColumnLists[key] ?? {};

  return Object.entries(translatedColumnList).map(([englishValue, localValue]) => ({
    label: localValue,
    value: englishValue,
  }));
};
